import axios from '@/api/axios'

const createTraining = trainerInput => {
  return axios.post('/trainings', trainerInput)
}

const getTrainings = () => {
  return axios.get('/trainings')
}

const getTrainingsList = params => {
  return axios.get('/trainings/list', {params})
}

const getTrainingsBySchoolId = params => {
  return axios.get(`/trainings`, {params})
}

const getTraining = id => {
  return axios.get(`/trainings/${id}`)
}

const updateTraining = (id, trainerInput) => {
  return axios.put(`/trainings/${id}`, trainerInput)
}

const deleteTraining = id => {
  return axios.delete(`/trainings/${id}`)
}

export default {
  createTraining,
  getTrainings,
  getTrainingsList,
  getTraining,
  updateTraining,
  deleteTraining,
  getTrainingsBySchoolId
}
